var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","padding-top":"50px"}},[_c('h1',[_vm._v("Cargando documento...")]),_c('p',[_vm._v("Si la redirección no funciona, haga clic "),_c('a',{attrs:{"href":_vm.fileUrl,"target":"_self"}},[_vm._v("aquí")]),_vm._v(".")])])
}
var staticRenderFns = []

export { render, staticRenderFns }